import * as R from 'ramda'

export const mapAccountPreferences = R.compose(json => {
  const gradeJson = json['grade']
  const grades = gradeJson === 'all' ? gradeJson : []
  if (R.is(Array, gradeJson)) {
    gradeJson.map(g => {
      if (g === 'a') {
        return grades.push('low')
      } else if (g === 'b') {
        return grades.push('medium')
      } else if (g === 'c') {
        return grades.push('high')
      } else {
        return grades.push('all')
      }
    })
  }
  return {
    loanAmount: R.defaultTo('', json['loan_amount']),
    minInvestment: R.defaultTo('', json['min_investment']),
    maxInvestment: R.defaultTo('', json['max_investment']),
    tenor: R.defaultTo('all', json['tenor']),
    riskCategory: R.defaultTo('all', grades)
  }
}, R.defaultTo({}))
